import request from '@/utils/request'

// 参数接口
export interface SendCodeParams {
  /*手机号 */
  phone: string

  /*时间戳 */
  timestamp?: number

  /*签名 = MD5(deviceId + appVersion + deviceType + phone + timestamp + APPSECRET); APPSECRET使用：Ku^jg9%am@jIzh8 */
  sign?: string
}

// 响应接口
export interface SendCodeRes {
  code: number
  message: string
  data: string
}

export interface LoginParams {
  /*手机号 */
  phone: string

  /*短信验证码 */
  code: string

  /*时间戳 */
  timestamp?: number

  /*签名 = MD5(deviceId + appVersion + deviceType + code + phone + timestamp + APPSECRET) */
  sign?: string

  /*用于页面数据统计和追踪，json结构 */
  deeplink?: {
    [key: string]: unknown
  }
}

export interface LoginRes {
  code: number
  message: string
  data: {
    token: string
    /** 雪花等大整数请服务端以 JSON 字符串返回，避免 JavaScript 精度丢失 */
    id: number | string
    nickname: string
    avatar: string
    signature: string | null
    phone: string
    userNum: number
    grade: string
    province: string
    provinceCode: number
    city: string
    cityCode: number
    district: string
    districtCode: number
    userIdentity: string
    firstLogin: boolean
    imSig: string | null
    deviceId: string
  }
}

/**
 * 获取短信验证码
 * @param {object} params 短信验证码
 * @param {string} params.phone 手机号
 * @param {number} params.timestamp 时间戳
 * @param {string} params.sign 签名
 * @returns
 */
export function sendCode(params: SendCodeParams): Promise<SendCodeRes> {
  return request.post(`/ai-api/v1/login/sendCode`, params)
}

/**
 * 用户-登陆-注册
 * @param {object} params 登陆参数
 * @param {string} params.phone 手机号
 * @param {string} params.code 短信验证码
 * @param {number} params.timestamp 时间戳
 * @param {string} params.sign 签名
 * @param {object} params.deeplink 用于页面数据统计和追踪，json结构
 * @returns
 */
export function login(params: LoginParams): Promise<LoginRes> {
  return request.post(`/ai-api/v1/login/codeLogin`, params)
}
